export const fovScenes = [
  {
    sceneId: '675a6490fef38c25a3605f6c',
    zoomOutFov: 100,
  },
  {
    sceneId: '675962455444e18f4b62d6b3',
    zoomOutFov: 100,
  },
  {
    sceneId: '67595f0a5444e18f4b62d361',
    zoomOutFov: 100,
  },
  {
    sceneId: '675952915444e18f4b62c003',
    zoomOutFov: 100,
  },
];

export const titleScenes = [
  {
    sceneId: '67e26adbd10d75c7dcedf2a8',
    title: 'KHU MÁY TẬP THỂ DỤC',
  },
  {
    sceneId: '67e26abdd10d75c7dcedf28d',
    title: 'KHU MÁY TẬP THỂ DỤC',
  },
  {
    sceneId: '67e26aadd10d75c7dcedf284',
    title: 'LỐI ĐI CÔNG VIÊN',
  },
  {
    sceneId: '67e26ac6d10d75c7dcedf296',
    title: 'LỐI ĐI CÔNG VIÊN',
  },
  {
    sceneId: '67e26a76d10d75c7dcedf256',
    title: 'LỐI ĐI CÔNG VIÊN',
  },
  {
    sceneId: '67e26a8ad10d75c7dcedf268',
    title: 'LỐI ĐI CÔNG VIÊN',
  },
];

export const outsideGroup = [
  {
    groupId: '676ff311148d830ff5b1aeb2',
  },
  {
    groupId: '67ebb568ead9d8bd5faf4672',
  },
  {
    groupId: '67ebb1dfead9d8bd5faf4183',
  },
];
